import {
  BACKSPLASH_INPUT_LIMIT,
  WATERFALL_INPUT_LIMIT,
} from '~/core/constants';
import { SideItemType } from '~/core/enums';
import { roundToArrowLengthGranularity } from '~/core/helpers';
import { SideItemInfoModel } from '~/core/models';
import { clampWithLimit } from '~/core/utils';

/**
 * Update the side item height with the last entered length
 */
export const updateSideItemHeight = (
  sideItem: SideItemInfoModel,
  inputValue: number
): SideItemInfoModel => {
  const roundValue = roundToArrowLengthGranularity(inputValue);
  const fieldsBy: Record<SideItemType, Partial<SideItemInfoModel>> = {
    [SideItemType.WATERFALL]: {
      waterfallHeight: clampWithLimit(roundValue, WATERFALL_INPUT_LIMIT),
    },
    [SideItemType.APPLIANCE_SIDE]: {},
    [SideItemType.WALL_SIDE]: {
      backsplash: {
        checked: true,
        height: clampWithLimit(roundValue, BACKSPLASH_INPUT_LIMIT),
      },
    },
    [SideItemType.END_CAP]: {},
    [SideItemType.END_SPLASH]: {},
  };

  return {
    ...sideItem,
    ...fieldsBy[sideItem.sideType],
    lastEnteredLength: inputValue,
  };
};
